import React from 'react';
import Popover from '@mui/material/Popover';
import { Checkbox } from '@mui/material';

const StyledPopover = ({ anchorEl, setAnchorEl, availableModesOptions, setAvailableModesOptions, setMode }) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Popover
        id="simple-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        {availableModesOptions.map((availableOption, index) => {
          return (
            <div key={availableOption.label + index} style={{ marginRight: '5px', textAlign: 'left' }}>
              <Checkbox
                checked={availableOption.isSelected}
                onChange={() => {
                  if (!availableOption.isSelected) {
                    let updatedAvailableOption = [...availableModesOptions];
                    availableModesOptions.forEach((availableOption) => {
                      availableOption.isSelected = false;
                    });
                    updatedAvailableOption[index].isSelected = true;
                    setAvailableModesOptions(updatedAvailableOption);
                    setMode(updatedAvailableOption[index]);
                  }
                }}
              />
              <div style={{ width: '60px', marginRight: '5px', display: 'inline' }}> {availableOption.label}</div>
            </div>
          );
        })}
      </Popover>
    </div>
  );
};

export default StyledPopover;
